export default __webpack_public_path__ + "static/media/fast-send-img.d7d91241.svg";